import r, { useContext as a, createContext as n } from "react";
const o = n(!1), c = ({
  darkMode: e = !1,
  children: t
}) => /* @__PURE__ */ r.createElement(o.Provider, { value: e }, t), d = (e) => {
  const t = a(o);
  return e !== void 0 ? e : t;
};
export {
  c as D,
  d as u
};
